<template>
  <div>
    <div class="mt-4">
      <AlertBannerRecords path="/vehicles" :message="vehiclesMessage" />
      <AlertBannerRecords path="/maestro/tickets" :message="scheduleMessage" />
    </div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Placa, AIT ou Renavam"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query" @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgesFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-6">
        <div class="col-md-6">
          <label>Empresas</label>
          <Select2 :options="filterCnpjs" v-model="query.cnpj"/>
        </div>

        <div class="col-md-6">
          <label>Órgão autuador</label>
          <Select2 :options="filterIssuingAuthority" v-model="query.issuingAuthority"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label>Status da Infração</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>

        <div class="col-md-4">
          <label>Classe</label>
          <Select2 :options="filterTicketClass" v-model="query.ticketClass"/>
        </div>

        <div class="col-md-4">
          <label>Marcadores</label>
          <Select2 :options="filterLabels" v-model="query.labelId"/>
        </div>
      </div>

      <div class="row mt-4">
        <div :class="allowCrossing() ? 'col-md-4' : 'col-md-6'">
          <label>Status do Veículo</label>
          <select v-model="query.entityStatusId" class="browser-default custom-select">
            <option v-for="opt in (filterEntityStatusId ? filterEntityStatusId.table : [])" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div v-if="allowCrossing()" class="col-md-4">
          <label>Motoristas</label>
          <Select2 :options="filterDrivers" v-model="query.cpf"/>
        </div>

        <div :class="allowCrossing() ? 'col-md-4' : 'col-md-6'">
          <label>Código da frota</label>
          <Select2 :options="filterFleetCode" v-model="query.fleetCode"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="occurred_at">Data da infração</option>
            <option value="created_at">Data de criação</option>
            <option value="expired_at">Data de vencimento</option>
            <option value="boleto_due_date">Data de vencimento do boleto</option>
            <option value="indication_deadline">Prazo de indicação</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>

    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button
          v-if="$withPolicy('cm-frotas', 'consult')"
          class="btn btn-primary mt-1 mr-1"
          @click="showModal = true"
          >
          Consulta avulsa
        </button>

        <Dropdown
          title-dropdown="Exportar"
          class="btn btn-primary mt-1 mr-1"
          :enable="someTicketSelected"
        >
          <ul class="mb-1 mt-1">
            <li
                v-if="$withPolicy('cm-frotas', 'download_xlsx')"
                class="dropdown-item" @click="toXLSX()"
            >
              Multas
            </li>
            <li
                v-if="$withPolicy('cm-frotas', 'download_xlsx')"
                class="dropdown-item" @click="toXLSX(true)"
            >
              Multas + Dados Adicionais do Veículo
            </li>
            <li
                v-if="$canDownload('cm-frotas', 'download_boleto', 'download_fici', 'download_demonstrativo', 'download_notification')"
                class="dropdown-item" @click="showDocumentExporter = true"
            >
              Documentos
            </li>
            <li
                v-if="allowCustomReport() && $withPolicy('cm-frotas', 'download_xlsx')"
                class="dropdown-item" @click="toCustomReport()"
            >
              Relatório de Multas Customizado
            </li>
          </ul>
        </Dropdown>

        <template v-if="$withPolicy('cm-frotas', 'consult_history')">
          <button
              class="btn btn-primary mt-1 mr-1"
              @click="$router.push('/cm-frotas/consultas')"
          >
            Histórico de consultas
          </button>
        </template>

        <template v-if="getUser.brobotStaff">
          <router-link
              tag="button"
              to="/cm-frotas/configuracoes"
              class="btn btn-primary mt-1 mr-1"
          >
            Configurações
          </router-link>
        </template>

        <button
          v-if="allowCrossing()"
          class="btn btn-primary mt-1 mr-1"
          @click="showScheduleCrossingModal = true"
          v-tooltip.right="{ content: 'Baixe e preencha o arquivo modelo conforme as instruções. Após o envio, o sistema fará automaticamente o cruzamento das multas com o condutor vinculado ao veículo na data da infração.' }"
        >
          Cruzamento
        </button>

        <button
          class="btn btn-outline mt-1 float-right relative"
          @click="showSelectColumns = true"
        >
          Mostrar colunas
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
          <template v-if="meta.lastConsult">
            Última consulta realizada em: {{ meta.lastConsult | datetime }}
          </template>
        </small>

        <button class="btn btn-outline ml-3 mb-1"
                v-if="tickets.length > 0"
                @click="changeCheck({checkAll: !checkAll, sources: tickets})"
                :class="{ 'btn-outline-active': checkAll }">
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="order" @change="updateOrder(order)" class="browser-default custom-select">
            <option :value="['occurred_at', 'desc']">Data da infração</option>
            <option :value="['updated_at', 'desc']">Data de atualização</option>
            <option :value="['created_at', 'desc']">Data de criação</option>
            <option :value="['expired_at', 'desc']">Data de vencimento</option>
            <option :value="['indication_deadline', 'desc']">Prazo de indicação</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <Table
          :tickets="tickets"
          :labels="labels"
          :columns="selectedColumns"
          :entity-status-names="entityStatusNames"
          @changeCheckAllRow="changeCheckAllRow"
          @changeCheckRow="changeCheckRow"
          @fetchTickets="asyncTemplateSelect({ pagination: true })"
          @changeLabels="buildFilterLabels()"
          :check-all-row="checkAllRow"
        />

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <!-- Modal request vehicle -->
    <VehicleRequestModal v-model="showModal" appName="cm-frotas" width="lg"/>

    <!-- Modal selected columns -->
    <Modal v-model="showSelectColumns" width="lg">
      <div slot="header">
        Mostrar colunas
      </div>

      <div>
        <p>Selecione as colunas que deseja visualizar na tabela do CaçaMultas:</p>
      </div>

      <table class="columnsSelector table table-borderless table-border table-align">
        <thead>
          <tr>
            <th></th>
            <th>Nome da Coluna</th>
            <th>Descrição</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="column in sortedTableColumns" :key="column.key">
            <td>
              <input
                  type="checkbox"
                  :id="column.key"
                  v-model="column.checked"
                  @change="updateColumnsInLocalStorage"
                  class="cursor-pointer"
              />
            </td>
            <td>{{ column.label }}</td>
            <td>{{ column.description }}</td>
          </tr>
        </tbody>
      </table>
    </Modal>

    <Report ref="report"/>

    <!-- Modal schedule crossing -->
    <ScheduleCrossingModal
      v-model="showScheduleCrossingModal"
      @start-loading="openGlobalLoad"
      @stop-loading="closeGlobalLoad"
      @upload-success="onUploadSuccess"
    />

    <DocumentExporterModal
      v-model="showDocumentExporter"
      :selected-tickets="selectedTickets"
      :check-all="checkAll"
      :total-count="meta.totalCount"
      :build-params="buildParams"
    />
  </div>
</template>

<script>
  import AlertBannerRecords from '@/components/shares/AlertBannerRecords'
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import CheckedModels from '@/mixins/CheckedModels'

  import Dropdown from '../shares/specialTag/Dropdown'
  import Formatter from '@/models/Formatter'
  import GetAccount from '@/mixins/GetAccount.vue'
  import GetUser from '@/mixins/GetUser.vue'

  import Modal from '../shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'

  import Select2 from '@/components/shares/Select2'
  import Table from '@/components/cm-frotas/Table'
  import VehicleRequestModal from '../vehicles/VehicleRequestModal'

  import DocumentExporterModal from '@/components/cm-frotas/DocumentExporterModal'
  import Report from '@/components/cm-frotas/Report'
  import ScheduleCrossingModal from './ScheduleCrossingModal'

  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  import { IBGE } from '@/models/ibge'
  import { IssuingAuthority } from '@/models/IssuingAuthority'
  import { VEHICLE_STATUS, VEHICLE_STATUS_OPTIONS, VEHICLE_STATUS_FILTER_TABLE } from '@/utils/vehicleStatus'
  import Sorter from '@/models/Sorter'

  const cityHallName = (cityCode) => cityCode && IBGE.getByCityCode(cityCode)?.name
  const authority = (value) => IssuingAuthority.label(value)
  const translateStatus = value => {
    return {
      canceled: 'Cancelado',
      expired: 'Vencido',
      opened: 'Em aberto',
      not_available: 'Saiu do site',
      undefined: '',
      paid: 'Pago',
      prescribed: 'Prescrito',
      autuacao: 'Autuação',
      em_recurso: 'Em recurso',
      encerrado: 'Encerrado',
      outros: 'Outros',
    }[value]
  }

  const statusTable = [
    ['cancelado', 'canceled'],
    ['vencido', 'expired'],
    ['pago', 'paid'],
    ['prescrito', 'prescribed'],
    ['em aberto', 'opened'],
    ['saiu do site', 'not_available'],
    ['sem informação', 'undefined'],
    ['autuação', 'autuacao'],
    ['em recurso', 'em_recurso'],
    ['encerrado', 'encerrado'],
    ['outros', 'outros']
  ]

  const keyTemplateColumns = 'ticketTemplateColumns'
  const keyOrderby = 'ticketOrderBy'
  const fiveYearsInMinutes = 60 * 24 * 30 * 12 * 5
  const tableColumns = [
    { key: 'ait', label: 'AIT', checked: true, description: 'Número do auto de infração' },
    { key: 'plate', label: 'Placa', checked: true, description: 'Placa do veículo' },
    { key: 'renavam', label: 'Renavam', checked: true, description: 'Número do Renavam (Registro Nacional de Veículos Automotores)' },
    { key: 'cnpj', label: 'CNPJ', checked: false, method: Formatter.cnpj, description: 'Número do CNPJ (Cadastro Nacional da Pessoa Jurídica)' },
    { key: 'status', label: 'Status da Infração', checked: true, method: translateStatus, description: 'Status da infração' },
    { key: 'entityStatusId', label: 'Status do Veículo', checked: true, description: 'Status do veículo' },
    { key: 'valueCents', label: 'Valor', checked: true, method: Formatter.centsToPrice, description: 'Valor da infração' },
    { key: 'paid_amount_cents', label: 'Valor Pago', checked: false, method: Formatter.centsToPrice, description: 'Valor pago (informação retornada pelo órgão consultado, porém nem todos os órgãos retornam esta informação)' },
    { key: 'amount_to_pay_cents', label: 'Valor a pagar', checked: false, method: Formatter.centsToPrice, description: 'Valor a pagar' },
    { key: 'occurredAt', label: 'Data da Infração', checked: true, method: Formatter.stringToDatetime, description: 'Data da infração' },
    { key: 'ticketClass', label: 'Classe', checked: false, description: 'Classe da multa' },
    { key: 'ticketSubclass', label: 'Subclasse', checked: false, description: 'Subclasse da multa' },
    { key: 'situation', label: 'Situação', checked: true, description: 'Situação ou condição' },
    { key: 'code', label: 'Código', checked: false, description: 'Código da infração' },
    { key: 'fleetCode', label: 'Código da Frota', checked: false, description: 'Código da frota do veículo' },
    { key: 'description', label: 'Descrição', checked: false, description: 'Descrição da infração' },
    { key: 'local', label: 'Local', checked: false, description: 'Local da infração' },
    { key: 'cityCode', label: 'Cidade', checked: false, method: cityHallName, description: 'Cidade' },
    { key: 'uf', label: 'UF', checked: false, description: 'Unidade federativa' },
    { key: 'points', label: 'Pontuação', checked: false, description: 'Pontuação' },
    { key: 'issuingAuthority', label: 'Órgão autuador', checked: true, description: 'Órgão autuador', method: authority },
    { key: 'issuingAuthorityCode', field: 'issuingAuthority', label: 'Código do órgão autuador', checked: false, description: 'Código do órgão autuador' },
    { key: 'related_ticket', label: 'AIT original', checked: false, description: 'Auto de infração original relacionado à multa' },
    { key: 'appealDeadline', label: 'Prazo de Recurso', checked: false, description: 'Prazo limite de recurso', method: Formatter.stringToDate },
    { key: 'indicationDeadline', label: 'Prazo de Indicação', checked: false, description: 'Prazo limite de indicação do condutor', method: Formatter.stringToDate },
    { key: 'notificationDate', label: 'Data da Notificação da Autuação', checked: false, description: 'Data da notificação de autuação (disponível para multas do SNE)', method: Formatter.stringToDate },
    { key: 'penaltyNotificationDate', label: 'Data da Notificação de Penalidade', checked: false, description: 'Data da notificação de penalidade (disponível para multas do SNE)', method: Formatter.stringToDate },
    { key: 'expiredAt', label: 'Data de Vencimento', checked: true, method: Formatter.stringToDate, description: 'Data de vencimento' },
    { key: 'paid_at', label: 'Data de Pagamento', checked: false, method: Formatter.stringToDate, description: 'Data de pagamento (informação retornada pelo órgão consultado, porém nem todos os órgãos retornam esta informação)' },
    { key: 'boleto_due_date', label: 'Data de Vencimento do Boleto', checked: true, method: Formatter.stringToDate, description: 'Data de vencimento do boleto retornado na última consulta' },
    { key: 'barcode_digits', label: 'Linha digitável', checked: true, description: 'Linha digitável/código de barras do último boleto baixado' },
    { key: 'createdAt', label: 'Criado em', checked: false, method: Formatter.stringToDatetime, description: 'Criado em' },
    { key: 'updatedAt', label: 'Atualizado em', checked: true, method: Formatter.stringToDatetime, description: 'Atualizado em' },
    { key: 'observation', label: 'Observação', checked: false, description: 'Observação interna registrada na multa' },
    { key: 'cpf', label: 'CPF', checked: false, method: Formatter.cpf, description: 'CPF do condutor', allowCrossing: true },
    { key: 'driver.name', label: 'Motorista', checked: false, description: 'Nome do motorista', allowCrossing: true },
    { key: 'driver.kind', label: 'Categoria do motorista', checked: false, description: 'Categoria do motorista', allowCrossing: true },
  ]

  export default {
    components: {
      AlertBannerRecords,
      BadgeFilters, ChevronDownIcon, DocumentExporterModal, Dropdown,
      VehicleRequestModal, Modal, Pagination,
      SearchIcon, Select2, Table,
      Report, ScheduleCrossingModal
    },
    computed: {
      badgesFilters() {
        return [
          this.filterIssuingAuthority,
          this.filterCnpjs, this.filterDrivers, this.filterStatus, this.filterEntityStatusId,
          this.filterEndDate, this.filterStartDate, this.filterTicketClass, this.filterLabels,
          this.filterFleetCode
        ].filter(Boolean)
      },
      selectedTickets() {
        return this.tickets.filter(ticket => ticket.checked)
      },
      someTicketSelected() {
        return this.checkAll || this.tickets.some(ticket => ticket.checked)
      },
      tickets() {
        return this.getModels || []
      },
      selectedColumns() {
        return this.tableColumns.filter(column => column.checked)
      },
      sortedTableColumns() {
        return Sorter.sortBy(this.tableColumns, 'label')
      },
    },
    created() {
      if (this.allowCrossing())
        this.tableColumns = tableColumns
      else
        this.tableColumns = tableColumns.filter(column => !column.allowCrossing)

      const order = this.$ls.get(keyOrderby)
      this.order = order || ['updated_at', 'desc']
      this.methods = ['label_ids', 'last_boleto', 'last_notification', 'vehicle']
      if (this.allowCrossing())
        this.includes.push('driver')

      if (this.allowCrossing()) {
        this.methods.push('driver')
      }
      this.$set(this.query, 'periodType', 'updated_at')
      this.$set(this.query, 'entityStatusId', String(VEHICLE_STATUS.ENABLED))
      this.defaultModelSetting.updateQueryURL = true

      this.asyncTemplateSelect({
        byURL: true,
        pagination: true,
        finish: () => this.loadFilters()
      })

      this.loadLabels()
      this.loadEntityStatus()

      this.initializersTableColumns()
    },
    data: () => ({
      labels: [],
      filterCnpjs: null,
      filterDrivers: null,
      filterIssuingAuthority: null,
      filterFleetCode: null,
      filterTicketClass: null,
      filterLabels: null,
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterEntityStatusId: null,
      entityStatusNames: {},
      filterStatus: new Filter({
        key: 'status',
        label: 'Status da Infração',
        table: statusTable
      }),
      modelPathPrefix: 'maestro',
      nameModel: 'Ticket',
      showDocumentExporter: false,
      showFilter: false,
      showModal: false,
      showSelectColumns: false,
      showScheduleCrossingModal: false,
      vehicles: [],
      tableColumns: [],
      vehiclesMessage: 'Ainda não existem veículos cadastrados no sistema. <a href="/definitions?tab=vehicles">Clique aqui</a> para ir para o cadastro de veículos.',
      scheduleMessage: 'Ainda não existem multas registradas no sistema. <a href="/cm-frotas/configuracoes">Clique aqui</a> para ir para o agendamento de consultas.',
    }),
    filters: {
      authority(code) {
        return IssuingAuthority.label(code)
      }
    },
    methods: {
      updateOrder(order) {
        this.find()
        this.$ls.set( keyOrderby, order, { minutes: fiveYearsInMinutes })
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.tickets })
      },
      changeCheckRow(){
        this.changeCheck({ sources: this.tickets })
      },
      find() {
        this.asyncTemplateSelect()
      },
      async loadFilters() {
        const methods = [
          this.loadCompanies, this.loadIssuingAuthorities,
          this.loadTicketClass, this.loadLabels, this.loadFleetCodes,
          this.loadStatus
        ]

        if (this.allowCrossing()) {
          methods.push(this.loadDrivers)
        }

        for (const method of methods)
          await method()
      },
      loadCompanies() {
        const params = {
          q: {
            type: ['parent', 'subsidiary'],
          },
          per_page: 10000,
          meta: false
        }

        return this.axios.get('/companies', { params })
          .then(response => response.data)
          .then((companies) => this.buildFilterCnpj(companies))
      },
      buildFilterCnpj(companies) {
        const cnpjs = companies.map(company => [
          company.name + ' - ' + Formatter.cnpj(company.cnpj),
          company.cnpj
        ])

        this.filterCnpjs = new Filter({
          key: 'cnpj',
          label: 'CNPJ',
          table: cnpjs
        })
      },
      loadIssuingAuthorities() {
        return this.axios.get('/maestro/tickets/fetch_column/issuing_authority')
          .then(response => {
            this.filterIssuingAuthority = new Filter({
              key: 'issuingAuthority',
              label: 'Órgãos Autuadores',
              table: response.data.map(code => [IssuingAuthority.label(code), code])
            })
          })
      },
      loadFleetCodes() {
        return this.axios.get('vehicles/fetch_column/fleet_code')
          .then(response => {
            this.filterFleetCode = new Filter({
              key: 'fleetCode',
              label: 'Código da frota',
              table: response.data.filter(v => v).map(v => [v, v])
            })
          })
      },
      loadStatus() {
        return this.axios.get('/maestro/tickets/fetch_column/status')
          .then(response => {
            const visible = response.data || []
            this.filterStatus = new Filter({
              key: 'status',
              label: 'Status da Infração',
              table: statusTable.filter(([, value]) => visible.includes(value))
            })
          })
          .catch(() => {})
      },
      loadTicketClass() {
        return this.axios.get('/maestro/tickets/fetch_column/ticket_class')
          .then(response => {
            this.filterTicketClass = new Filter({
              key: 'ticketClass',
              label: 'Classe',
              table: response.data.filter(d => d).map(description => [description, description])
            })
          })
      },
      loadLabels() {
        return this.axios.get('/maestro/labels?meta=false&per_page=500')
          .then(response => this.labels = this.$parse.toCamelcase(response.data))
          .then(() => this.buildFilterLabels())
      },
      buildFilterLabels() {
        return this.filterLabels = new Filter({
          key: 'labelId',
          label: 'Marcador',
          table: [['Sem marcador', -1], ...this.labels.map(label => [label.name, label.id])]
        })
      },
      loadEntityStatus() {
        this.entityStatusNames = VEHICLE_STATUS_OPTIONS.reduce((map, s) => {
          map[s.id] = s.friendlyName
          return map
        }, {})

        this.filterEntityStatusId = new Filter({
          key: 'entityStatusId',
          label: 'Status do Veículo',
          type: 'select',
          table: VEHICLE_STATUS_FILTER_TABLE
        })

        const column = this.tableColumns.find(c => c.key === 'entityStatusId')
        if (column)
          column.description = 'Status do veículo (ativo, inativo ou excluído)'
      },
      loadDrivers() {
        return this.axios.get('/maestro/drivers?meta=false&per_page=10000')
          .then(response => response.data)
          .then((drivers) => this.buildFilterDrivers(drivers))
      },
      buildFilterDrivers(drivers) {
        const driverOptions = drivers.map(driver => [
          `${driver.name} - ${driver.kind} - ${Formatter.cpf(driver.cpf)}`,
          driver.cpf
        ])

        driverOptions.unshift(['Motorista excluído', 'Motorista excluído'])

        this.filterDrivers = new Filter({
          key: 'cpf',
          label: 'Motorista',
          table: driverOptions
        })
      },
      toXLSX(withVehicle) {
        let params
        let amount

        if (this.checkAll) {
          params = this.buildParams()
          amount = this.meta.totalCount
        } else {
          const ids = this.tickets.filter(c => c.checked).map(c => c.id)
          params = { q: { id: ids } }
          amount = ids.length
        }

        if (withVehicle)
          params['methods'] = ['vehicles']
        else
          params['methods'] = []

        this.$refs.report.requestReport(params, amount, this.allowCrossing())
      },
      initializersTableColumns() {
        const keys = this.$ls.get(keyTemplateColumns)
        if (!keys)
          return

        this.tableColumns.forEach(column => column.checked = keys.includes(column.key))
      },
      updateColumnsInLocalStorage() {
        const selectedKeys = [...new Set(this.tableColumns.filter(e => e.checked).map(e => e.key))]
        this.$ls.set(keyTemplateColumns, selectedKeys, { minutes: fiveYearsInMinutes })
      },
      onUploadSuccess() {
        // Handle successful upload if needed
      },
      allowCrossing() {
        return this.getAccount.metadata?.allowCrossing || null
      },
      allowCustomReport() {
        return this.getAccount.metadata?.relatoriofrotasEngemix || null
      },
      toCustomReport() {
        let params
        if (this.checkAll) {
          params = this.buildParams()
        } else {
          const ids = this.tickets.filter(c => c.checked).map(c => c.id)
          params = { q: { id: ids } }
        }
        params.methods = []
        params.template = 'engemix'

        this.openLoad()
        this.axios.get('maestro/tickets/report', { params })
          .then(response => {
            if (response.data)
              this.$parse.downloadByLink(response.data)
            else
              this.$notify.add(response.meta.notice)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      }
    },
    mixins: [ModelMapper, CheckedModels, GetAccount, GetUser],
    name: 'Index',
    watch: {
      showDocumentExporter(newValue) {
        if (!newValue)
          this.changeCheck({ checkAll: false, sources: this.tickets })
      },
      tickets(newValue, oldValue) {
        if (newValue !== oldValue)
          this.changeCheck({checkAllRow: false})
      }
    }
  }

</script>

<style scoped>
</style>
